import { Button, f7 } from 'framework7-react';
import { FC } from 'react';
import './prepaidButtonStyle.scss';
import style from './PrepaidButtonStyle.module.css';

interface PrepaidButtonProps {
  path: string;
  iconType: string;
  label: string;
  width?: number;
  height?: number;
  isDisabled?: boolean;
}

const defaultSize = 54;

export const PrepaidButton: FC<PrepaidButtonProps> = ({
  path,
  iconType,
  label,
  width = defaultSize,
  height = defaultSize,
  isDisabled = false,
}) => {
  const handleClickButton = () => {
    f7.views.main.router.navigate(path);
  };
  return (
    <div
      className={`${style['button-wrapper']} ${
        isDisabled ? style['disable'] : ''
      }`}
    >
      <Button
        onClick={!isDisabled ? handleClickButton : undefined}
        className={style['button']}
        round
        iconSize="54px"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          // backgroundColor: isDisabled ? '#E6E6E6' : '#fff',
        }}
        disabled={isDisabled}
      >
        <i className={`icon-${iconType}`} />
      </Button>
      <span className={style['label']}>{label}</span>
    </div>
  );
};
